import React, { useCallback } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import ShareItForwardSettings from "../../../components/shareItForward/ShareItForwardSettings";
import {
  getMediumPayItForward,
  enableMediumPayItForward,
  disableMediumPayItForward,
  saveMediumPayItForwardRules,
} from "../../../services/admin";

/**
 * Admin-side view of a specific medium's Share it Forward settings —
 * reached from the "Share it Forward" action on the Professional medium
 * list's side panel (src/pages/admin/mediums/professional/index.js). Same
 * shared UI as the medium's own self-service page
 * (src/pages/medium/payitforward/index.js), just pointed at a target
 * medium id (from the route) instead of "whoever is logged in," via the
 * admin-only endpoints in src/services/admin.js.
 */
export default function MediumShareItForward() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const mediumId = parseInt(id, 10);
  const mediumName = searchParams.get("name");

  // ShareItForwardSettings calls these with no arguments (it doesn't know
  // or care whether it's editing "the logged-in medium" or "a medium an
  // admin picked") — bind the target medium id here instead.
  const fetchSettingsApi = useCallback(() => getMediumPayItForward(mediumId), [mediumId]);
  const enableApi = useCallback(() => enableMediumPayItForward(mediumId), [mediumId]);
  const disableApi = useCallback(() => disableMediumPayItForward(mediumId), [mediumId]);
  const saveRulesApi = useCallback((payload) => saveMediumPayItForwardRules(mediumId, payload), [mediumId]);

  return (
    <ShareItForwardSettings
      crumbLabel={mediumName ? `Mediums / ${mediumName}` : "Admin Dashboard"}
      fetchSettingsApi={fetchSettingsApi}
      enableApi={enableApi}
      disableApi={disableApi}
      saveRulesApi={saveRulesApi}
    />
  );
}
